import styled from 'styled-components';

export const Form = styled.form`
  .center-button {
    display: flex;
    justify-content: center;
  }

  &.disabled-registration-form {
    pointer-events: none;
    opacity: 0.5;
  }
`;
